export const automatedQuoteGeneration = {
  dialogTitle: 'Automated quote generation not possible',
  information: "Don't worry, this has been escalated to a team member who will email you the quote instead",
  altImg: 'Cloud',
};
